/**
 * Securidou — Review Photo Lightbox
 * Full-screen image viewer for customer review photos.
 * Deferred, event-delegated, touch-swipe enabled.
 */
(function () {
  'use strict';

  function initReviewLightbox() {
    document.querySelectorAll('.pr-lightbox:not([data-lb-init])').forEach(function (lightbox) {
      lightbox.setAttribute('data-lb-init', 'true');

      var sectionId = lightbox.id.replace('pr-lightbox-', '');
      var dataEl = document.getElementById('pr-photos-data-' + sectionId);
      if (!dataEl) return;

      var photoData;
      try {
        photoData = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      /* Build lookup: reviewId → { images, name } */
      var reviewImages = {};
      photoData.forEach(function (entry) {
        reviewImages[entry.id] = { images: entry.images, name: entry.name };
      });

      /* State */
      var currentIndex = 0;
      var currentImages = [];
      var currentName = '';
      var lastFocused = null;
      var productTitle = document.title.split('–')[0].split('—')[0].split('|')[0].trim();

      /* DOM refs */
      var imgEl = lightbox.querySelector('.pr-lightbox-img');
      var prevBtn = lightbox.querySelector('.pr-lightbox-prev');
      var nextBtn = lightbox.querySelector('.pr-lightbox-next');
      var closeBtn = lightbox.querySelector('.pr-lightbox-close');
      var currentSpan = lightbox.querySelector('.pr-lightbox-current');
      var totalSpan = lightbox.querySelector('.pr-lightbox-total');
      var backdrop = lightbox.querySelector('.pr-lightbox-backdrop');
      var focusableEls = [closeBtn, prevBtn, nextBtn];

      function showImage(index) {
        currentIndex = index;
        imgEl.classList.remove('loaded');

        var url = currentImages[index];
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        imgEl.src = url + sep + 'width=1200';
        imgEl.alt = productTitle + ' \u2014 Photo avis client ' + currentName;

        imgEl.onload = function () {
          imgEl.classList.add('loaded');
        };

        currentSpan.textContent = index + 1;
        totalSpan.textContent = currentImages.length;

        lightbox.classList.toggle('single-image', currentImages.length <= 1);
        prevBtn.disabled = index === 0;
        nextBtn.disabled = index === currentImages.length - 1;
      }

      function open(reviewId, photoIndex) {
        var data = reviewImages[reviewId];
        if (!data || !data.images || data.images.length === 0) return;

        lastFocused = document.activeElement;
        currentImages = data.images;
        currentName = data.name;

        showImage(photoIndex || 0);

        lightbox.classList.add('open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function close() {
        lightbox.classList.remove('open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        imgEl.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        imgEl.classList.remove('loaded');
        currentImages = [];
        if (lastFocused) lastFocused.focus();
      }

      function goPrev() {
        if (currentIndex > 0) showImage(currentIndex - 1);
      }

      function goNext() {
        if (currentIndex < currentImages.length - 1) showImage(currentIndex + 1);
      }

      /* EVENT: thumbnail click (delegation on section) */
      var section = lightbox.closest('.section-product-reviews');
      if (!section) section = document.querySelector('.section-product-reviews');
      if (section) {
        section.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-lightbox-open]');
          if (!btn) return;
          open(btn.dataset.reviewId, parseInt(btn.dataset.photoIndex, 10) || 0);
        });
      }

      /* EVENT: close — button, backdrop, or click outside image */
      closeBtn.addEventListener('click', close);
      backdrop.addEventListener('click', close);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('pr-lightbox-content') || e.target.classList.contains('pr-lightbox-stage')) {
          close();
        }
      });

      /* EVENT: navigation */
      prevBtn.addEventListener('click', goPrev);
      nextBtn.addEventListener('click', goNext);

      /* EVENT: keyboard */
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('open')) return;

        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); return; }
        if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); return; }

        /* Focus trap */
        if (e.key === 'Tab') {
          var active = focusableEls.filter(function (el) { return !el.disabled; });
          if (active.length === 0) return;
          var first = active[0];
          var last = active[active.length - 1];

          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      });

      /* EVENT: touch swipe */
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var isSwiping = false;
      var SWIPE_THRESHOLD = 50;

      lightbox.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isSwiping = false;
      }, { passive: true });

      lightbox.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          isSwiping = true;
        }
        if (isSwiping) {
          e.preventDefault();
          touchDeltaX = dx;
          imgEl.style.transform = 'translateX(' + (touchDeltaX * 0.3) + 'px)';
        }
      }, { passive: false });

      lightbox.addEventListener('touchend', function () {
        if (isSwiping) {
          imgEl.style.transform = '';
          if (touchDeltaX > SWIPE_THRESHOLD) {
            goPrev();
          } else if (touchDeltaX < -SWIPE_THRESHOLD) {
            goNext();
          }
        }
        isSwiping = false;
        touchDeltaX = 0;
      }, { passive: true });
    });
  }

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewLightbox);
  } else {
    initReviewLightbox();
  }
})();
